import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InterviewDataService } from './services/interview-data.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'sample-question',
    templateUrl: './sample-question.component.html',
    standalone: false
})
export class SampleQuestionComponent implements OnInit, AfterViewInit {
    private translate = inject(TranslateService);
    attemptId: any;

    constructor(private _dataService: InterviewDataService, private _activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        this._activatedRoute.parent.params.subscribe((params) => {
            this._dataService.interviewId = params['id'];
            this._dataService.practice = true;
        });
    }

    ngAfterViewInit() {
        document.title = this.translate.instant('interviews.Sample Question Title');
        (document.querySelector('.mock-interviews-header h1') as HTMLElement)?.focus();
    }
}
